export default __webpack_public_path__ + "static/media/under_constr.7ef6a5a3.png";